module.exports = __webpack_public_path__ + "media/service_features/number_02-9da4d0a8.svg";